<template>
    <div class="physical-cc-payment-form">
        <form @submit.prevent="submit($event)" id="physical-cc-form" class="row">
            <div class="row m-0 p-0">
                <div class="col-6">
                    <label class="receipt-card d-flex flex-column justify-content-center align-items-center rounded p-3" for="file-input">
                        <div class="d-flex flex-column align-items-center">
                            <i class="fas fa-solid fa-receipt "></i>
                            <span class="h5 mt-3">{{ receiptInputStatus }}</span>
                        </div>
                        <img class="image-preview" ref="imagePreview">
                    </label>
                    <input 
                        :class="{'input': true, 'is-invalid': errors.has('physical-cc-receipt') }" 
                        name="physical-cc-receipt" 
                        id="file-input" 
                        @change="onFileChange" 
                        v-validate="'required'" 
                        type="file"
                        hidden
                    >
                </div>
                <div class="col-6 pl-0">
                    <div class="row m-0 p-0 mb-3">
                        <select 
                            :class="{'input': true, 'is-invalid': errors.has('physical-cc-type') }"
                            name="physical-cc-type" 
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            v-model="card.type"
                            id="physical-cc-type"
                            placeholder="Tipo de pagamento"
                        >
                            <option value="" disabled selected> Tipos de pagamento </option>
                            <option value="credit"> Crédito </option>
                            <option value="debit"> Débito </option>
                            <option value="pix"> PIX </option>
                        </select>
                        <div v-if="errors.has('physical-cc-type')" class="invalid-feedback px-0">
                            O tipo de pagamento é obrigatório.
                        </div>
                    </div>
                    <div class="row m-0 p-0 mb-3">
                        <select 
                            :class="{'input': true, 'is-invalid': errors.has('physical-cc-installments') }"
                            name="physical-cc-installments" 
                            v-validate="'required|min_value:1'"
                            type="text"
                            class="form-control"
                            v-model="card.installments"
                            id="physical-cc-installments"
                            placeholder="Parcelas"
                            :disabled="!card.type || ['debit', 'pix'].includes(card.type)"
                        >
                            <option value="0" disabled selected> Opções de parcelamento </option>
                            <option :value="item.number" v-for="item in installments" :key="item.number">
                                {{item.number.toString().padStart(2, '0')}}x {{ $t('de') }} {{ $n(item.value, 'currency', locale) }}
                            </option>
                        </select>
                        <div v-if="errors.has('physical-cc-installments')" class="invalid-feedback px-0">
                            A quantidade de parcelas é obrigatória.
                        </div>
                    </div>
                    <div v-show="admin.master === 'sim'" class="row m-0 p-0 mb-3">
                        <select 
                            :class="{'input': true, 'is-invalid': errors.has('physical-cc-machines') }"
                            name="physical-cc-machines" 
                            v-validate="'required'"
                            type="text"
                            class="form-control"
                            v-model="card.machine"
                            id="physical-cc-machines"
                            placeholder="Máquinas"
                        >
                            <option value="0" disabled> Opções de maquineta </option>
                            <option value="clube" selected> Clube </option>
                            <option value="dataclick"> Dataclick </option>
                        </select>
                        <div v-if="errors.has('physical-cc-machines')" class="invalid-feedback px-0">
                            A maquineta é obrigatória.
                        </div>
                    </div>
                    <div class="row m-0 p-0 mb-3">
                        <input 
                            id="physical-cc-code"
                            class="form-control"
                            type="text"
                            name="physical-cc-code"
                            placeholder="Código de autorização"
                            v-validate="'required'"
                            v-model="card.authorizationCode"
                        >
                        <div v-if="errors.has('physical-cc-code')" class="invalid-feedback px-0">
                            O código de autorização é obrigatório.
                        </div>
                    </div>
                    <div class="row justify-content-end mt-1">
                        <div class="col-3">
                            <button class="btn btn-block btn-dark" @click="cancel" :disabled="loading">Voltar</button>
                        </div>
                        <div class="col-4" @click="submit">
                            <button v-if="!loading" class="btn btn-block btn-success">Gerar cobrança</button>
                            <button v-else class="form-control btn-disabled d-flex justify-content-center align-items-center" type="button" disabled>
                                <div class="spinner-border text-dark" role="status"></div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row m-0 p-0 mt-2">
                <span :class="{'input': true, 'is-invalid': errors.has('physical-cc-receipt') }"></span>
                <div v-if="errors.has('physical-cc-receipt')" class="invalid-feedback">
                    O comprovante de pagamento é obrigatório.
                </div>
            </div>
            <div class="row m-0 p-0 mt-2">
                <div class="col">
                    <div class="alert alert-warning mb-0" role="alert">
                        <p class="h6"><strong>1.</strong> Selecione o tipo de pagamento realizado (crédito, débito ou PIX).</p>
                        <p class="h6"><strong>2.</strong> Em caso de crédito, selecione a quantidade de parcelas.</p>
                        <p class="h6"><strong>3.</strong> Digite o código de autorização.</p>
                        <p class="h6 mb-0"><strong>4.</strong> Anexe o comprovante de pagamento.</p>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    data() {
        return {
            card: {
                type: '',
                installments: 0,
                authorizationCode: null,
                machine: 'clube',
                receipt: null
            },
        }
    },
    props: {
        cart: {
            required: true,
            type: Array,
        },
        installments: {
            required: true,
            type: Array,
        },
        products: {
            required: true,
            type: Array,
        },
        admin: {
            required: true,
            type: Object,
        },
        loading: {
            default: false,
            type: Boolean
        },
    },
    computed: {
        receiptInputStatus() {
            return this.receipt ? 'Comprovante de pagamento' :'Anexe o comprovante de pagamento'
        },
        locale() {
            return window.locale.replace('_', '-')
        },
    },
    methods: {
        async submit($event) {
            $event.preventDefault()
            $event.stopPropagation()
            
            await this.$validator.validate()

            if (this.$validator.errors.count() !== 0) {
                this.$emit('error', 'Erro de validação')
                return
            }

            try {
                this.loading = true
                
                const token = await window.generateRecaptchaToken();

                const receiptFile = card.receipt
                delete card.receipt
                
                const formData = new FormData()
                formData.append('token', token)
                formData.append('type', 'credito-fisico')
                formData.append('cart', JSON.stringify(this.cart))
                formData.append('card', JSON.stringify(this.card))
                if (this.products.length === 0) {
                    formData.append('products', JSON.stringify([]))
                } else {
                    formData.append('products', JSON.stringify(this.products))
                }
                formData.append('file', receiptFile)
                
                const response = await axios.post('/api/payment/sign', formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                
                this.$emit('submit', response.data.order)
            } catch (error) {
                this.$emit('error', error.response.data.message ?? error.response.data.error)
                this.loading = false
            }
        },
        cancel() {
            this.$emit('close')
        },
        onFileChange(event) {
            const file = event.target.files[0]
            this.receipt = file
            
            const fr = new FileReader()
            fr.addEventListener('load', event => {
                this.$refs.imagePreview.src = event.target.result
            })
            fr.readAsDataURL(file)
        }
    },
    watch: {
        'card.type'(newValue) {
            if (['debit', 'pix'].includes(newValue)) {
                this.card.installments = 1
            }
        }
    }
});
</script>

<style scoped>

    .spinner-border {
        height: 1rem;
        width: 1rem;
    }
    
    .receipt-card {
        width: 100%;
        height: 100%;
        cursor: pointer;
        background-color: #ddd;
    }
    
    .receipt-card i {
        font-size: 60px;
    }
    
    .image-preview {
        max-width: 100%;
        max-height: 400px;
    }
    
</style>
